import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacidad from "../pages/privacidad/page";
import Terminos from "../pages/terminos/page";
import Cookies from "../pages/cookies/page";
import HoustonPage from "../pages/landing/houston-page";
import AssessmentPage from "../pages/landing/assessment-page";
import LawFirmsPage from "../pages/landing/law-firms-page";
import LogisticsPage from "../pages/landing/logistics-page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ai-automation-agency-houston/",
    element: <HoustonPage />,
  },
  {
    path: "/ai-readiness-assessment/",
    element: <AssessmentPage />,
  },
  {
    path: "/industries/ai-agents-for-law-firms/",
    element: <LawFirmsPage />,
  },
  {
    path: "/industries/ai-automation-for-logistics/",
    element: <LogisticsPage />,
  },
  {
    path: "/privacidad",
    element: <Privacidad />,
  },
  {
    path: "/terminos",
    element: <Terminos />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
